// extracted by mini-css-extract-plugin
module.exports = {"dotContainer":"_1sZWZiV","dotItem":"_3uk59JP","dot":"_2Syihpy","dot__selected":"j88DlNp"};